import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { AutoGroupReservationRequestsResponseDto } from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

export enum GroupingStrategy {
  STRICT = "STRICT",
  BEST_EFFORT = "BEST_EFFORT",
}

interface AutoGroupParams {
  locationId?: number;
  minGroupSize?: number;
  strategy?: GroupingStrategy;
}

export const useAutoGroupReservations = () => {
  return useMutation({
    mutationFn: async (
      params?: AutoGroupParams
    ): Promise<AutoGroupReservationRequestsResponseDto> => {
      const queryParams = new URLSearchParams();
      if (params?.locationId) {
        queryParams.append("locationId", params.locationId.toString());
      }
      if (params?.minGroupSize) {
        queryParams.append("minGroupSize", params.minGroupSize.toString());
      }
      if (params?.strategy) {
        queryParams.append("strategy", params.strategy);
      }

      const url = `api/admin/reservation-requests/auto-group${
        queryParams.toString() ? `?${queryParams.toString()}` : ""
      }`;

      const response = await apiFetch(url, {
        method: "POST",
      });

      if (!response.ok) {
        throw new Error(await getApiErrorMessage(response));
      }

      return response.json();
    },
  });
};
